/* ==================================================================
   KAAMI — comportements du thème
   ------------------------------------------------------------------
   Aucune donnée produit n'est écrite ici : prix, stock, titre, images
   et disponibilité viennent de Liquid. Ce fichier ne gère que les
   interactions.
   ================================================================== */

/* ------------------------------------------------------------------
   DÉFILEMENT LISSÉ
   La page glisse vers la position visée avec une inertie douce,
   retenue dans le hero puis normale. Le défilement natif du navigateur
   reste utilisé (pas de transform sur le body) : le menu collant, les
   colonnes sticky et les ancres continuent de fonctionner.
   Désactivé sur écran tactile et si le visiteur a demandé à réduire
   les animations.
   ------------------------------------------------------------------ */
(function () {
  var mm = window.matchMedia;
  var reduce = mm && mm('(prefers-reduced-motion: reduce)').matches;
  var coarse = mm && mm('(pointer: coarse)').matches;

  window.KAAMI_SCROLL_TO = function (y) { window.scrollTo({ top: y, behavior: 'smooth' }); };
  window.KAAMI_SCROLL_SET = function (y) { window.scrollTo(0, y); };
  if (reduce || coarse) return;

  var EASE_HERO = 0.030;
  var EASE_BASE = 0.075;
  var target = window.scrollY, cur = target, running = false, self = false;

  function maxY() { return Math.max(0, document.documentElement.scrollHeight - window.innerHeight); }
  function clamp(y) { return Math.min(Math.max(0, y), maxY()); }
  function put(y) { self = true; window.scrollTo(0, y); self = false; }

  function heroT(y) {
    var hero = document.querySelector('.hero');
    var h = hero ? hero.offsetHeight : 0;
    if (h <= 0) return 1;
    var t = y / (h * 0.85);
    return t <= 0 ? 0 : (t >= 1 ? 1 : t * t * (3 - 2 * t));
  }

  function loop() {
    var d = target - cur;
    if (Math.abs(d) < 0.4) { cur = target; put(cur); running = false; return; }
    var t = heroT(cur);
    cur += d * (EASE_HERO + (EASE_BASE - EASE_HERO) * t);
    put(cur);
    requestAnimationFrame(loop);
  }
  function start() { if (!running) { running = true; requestAnimationFrame(loop); } }

  document.documentElement.style.scrollBehavior = 'auto';

  window.addEventListener('wheel', function (e) {
    if (e.ctrlKey) return;
    if (e.target.closest && e.target.closest('.modal-card, .welc-card, .legal-body, .cart-drawer')) return;
    e.preventDefault();
    var d = e.deltaY;
    if (e.deltaMode === 1) d *= 16;
    else if (e.deltaMode === 2) d *= window.innerHeight;
    d *= 0.45 + 0.55 * heroT(target);
    target = clamp(target + d);
    start();
  }, { passive: false });

  window.addEventListener('scroll', function () {
    if (self || running) return;
    cur = target = window.scrollY;
  }, { passive: true });
  window.addEventListener('resize', function () { cur = target = window.scrollY; }, { passive: true });

  window.KAAMI_SCROLL_TO = function (y) { target = clamp(y); start(); };
  window.KAAMI_SCROLL_SET = function (y) { y = clamp(y); cur = target = y; running = false; put(y); };
})();


(function () {
  'use strict';

  var T = (window.KAAMI_STRINGS || {});
  function t(key, fallback) { return T[key] || fallback; }

  /* ================================================================
     PANIER SHOPIFY
     Vrai panier : /cart/add.js puis /cart.js. Le paiement reste
     entièrement géré par Shopify.
     ================================================================ */
  var cartCount = document.getElementById('cartCount');
  var toast = document.getElementById('toast');
  var toastTimer;

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }

  function paintCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.setAttribute('aria-label', n + (n > 1 ? ' articles' : ' article') + ' dans le panier');
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
      { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); return c; })
      .catch(function () { return null; });
  }

  function addToCart(variantId, quantity, label) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          showToast(res.data && res.data.description ? res.data.description
            : t('cart_error', "Ce produit n'a pas pu être ajouté."));
          return null;
        }
        showToast(label || t('cart_added', 'Ajouté au panier.'));
        return refreshCart();
      })
      .catch(function () {
        showToast(t('cart_error', "Ce produit n'a pas pu être ajouté."));
        return null;
      });
  }

  /* ================================================================
     FICHE PRODUIT — choix de la cure
     Chaque option porte sa variante et sa quantité, posées par Liquid.
     ================================================================ */
  var opts = [].slice.call(document.querySelectorAll('.opt'));
  var choice = null;

  function readOpt(el) {
    return {
      id: el.getAttribute('data-variant'),
      qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
      label: el.getAttribute('data-label') || '',
      price: el.getAttribute('data-price') || '',
      available: el.getAttribute('data-available') === 'true'
    };
  }

  function select(el) {
    if (!el) return;
    opts.forEach(function (o) { o.classList.remove('on'); o.setAttribute('aria-checked', 'false'); });
    el.classList.add('on');
    el.setAttribute('aria-checked', 'true');
    choice = readOpt(el);

    document.querySelectorAll('[data-add-price]').forEach(function (p) { p.textContent = choice.price; });
    document.querySelectorAll('[data-sticky-meta]').forEach(function (m) {
      m.textContent = choice.label + ', ' + choice.price;
    });
    document.querySelectorAll('form[data-product-form] [name="id"]').forEach(function (i) { i.value = choice.id; });
    document.querySelectorAll('form[data-product-form] [name="quantity"]').forEach(function (i) { i.value = choice.qty; });

    document.querySelectorAll('[data-add]').forEach(function (b) {
      b.disabled = !choice.available;
      if (!choice.available) b.setAttribute('data-soldout', 'true');
      else b.removeAttribute('data-soldout');
    });
  }

  opts.forEach(function (o) { o.addEventListener('click', function () { select(o); }); });
  if (opts.length) select(document.querySelector('.opt.on') || opts[0]);

  var sel3 = document.querySelector('[data-select-cycle]');
  if (sel3) {
    sel3.addEventListener('click', function () {
      var best = document.querySelector('.opt[data-preselect="true"]');
      select(best || opts[opts.length - 1]);
      window.KAAMI_SCROLL_TO(0);
    });
  }

  /* soumission : on passe par l'API pour garder le visiteur sur la page */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qty = form.querySelector('[name="quantity"]').value;
      var label = choice ? (choice.label + ', ' + choice.price) : null;
      var btn = form.querySelector('[data-add]');
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      addToCart(id, qty, label).then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; }
      });
    });
  });

  refreshCart();

  /* ================================================================
     GALERIES
     ================================================================ */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var imgs = gal.querySelectorAll('.gal-main img');
    var thumbs = gal.querySelectorAll('.thumb');
    thumbs.forEach(function (th, i) {
      th.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
        th.classList.add('on'); th.setAttribute('aria-pressed', 'true');
        imgs.forEach(function (im) { im.classList.remove('on'); });
        if (imgs[i]) imgs[i].classList.add('on');
      });
    });
  });

  /* ================================================================
     AVANT / APRÈS
     ================================================================ */
  var baCases = [].slice.call(document.querySelectorAll('[data-ba]'));
  baCases.forEach(function (c) {
    var ba = c.querySelector('.ba'), range = c.querySelector('.ba-range');
    if (!ba || !range) return;
    var apply = function () { ba.style.setProperty('--split', range.value + '%'); };
    range.addEventListener('input', apply); apply();
  });
  var baMode = 'side';
  function applyMode() {
    baCases.forEach(function (c) {
      var side = baMode === 'side';
      var ba = c.querySelector('.ba'), sd = c.querySelector('.ba-side');
      if (ba) ba.classList.toggle('off', side);
      if (sd) sd.classList.toggle('on', side);
    });
  }
  var seg = document.getElementById('baSeg');
  if (seg) {
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      seg.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      baMode = b.dataset.mode;
      applyMode();
    });
  }
  var baSel = document.getElementById('baCases');
  if (baSel) {
    baSel.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      baSel.querySelectorAll('button').forEach(function (x) { x.classList.remove('on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('on'); b.setAttribute('aria-pressed', 'true');
      var i = parseInt(b.dataset.case, 10);
      baCases.forEach(function (c, k) { c.classList.toggle('on', k === i); });
    });
  }
  applyMode();

  /* ================================================================
     ACCORDÉONS
     ================================================================ */
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var q = item.querySelector('.faq-q'), a = item.querySelector('.faq-a');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = item.classList.contains('open');
      item.classList.toggle('open', !open);
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      a.style.maxHeight = open ? '0px' : (a.scrollHeight + 'px');
    });
  });

  /* ================================================================
     « LIRE LA SUITE » DE LA SECTION HISTOIRE
     ================================================================ */
  var hist = document.getElementById('hist'),
    histMore = document.getElementById('histMore'),
    histBtn = document.getElementById('histToggle');
  if (hist && histMore && histBtn) {
    var histLabel = histBtn.querySelector('span');
    histBtn.addEventListener('click', function () {
      var open = hist.classList.toggle('open');
      histBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (histLabel) histLabel.textContent = open ? histBtn.getAttribute('data-close') : histBtn.getAttribute('data-open');
      if (open) {
        histMore.style.maxHeight = histMore.scrollHeight + 'px';
        setTimeout(function () {
          if (hist.classList.contains('open')) { histMore.style.maxHeight = 'none'; parallax(); }
        }, 1000);
      } else {
        histMore.style.maxHeight = histMore.scrollHeight + 'px';
        void histMore.offsetHeight;
        histMore.style.maxHeight = '0px';
      }
    });
    window.addEventListener('resize', function () {
      if (hist.classList.contains('open')) histMore.style.maxHeight = 'none';
    }, { passive: true });
  }

  /* ================================================================
     POP-UP DE BIENVENUE
     ================================================================ */
  var welc = document.getElementById('welcome');
  if (welc) {
    var WELC_KEY = 'kaami_welcome_v1';
    var delay = parseInt(welc.getAttribute('data-delay'), 10) || 6;
    function welcSeen() { try { return localStorage.getItem(WELC_KEY) === '1'; } catch (e) { return false; } }
    function welcMark() { try { localStorage.setItem(WELC_KEY, '1'); } catch (e) { } }
    function openWelc() {
      if (welc.classList.contains('open')) return;
      welc.classList.add('open');
      requestAnimationFrame(function () { welc.classList.add('in'); });
      welcMark();
      var f = welc.querySelector('input');
      setTimeout(function () { if (f) f.focus(); }, 450);
    }
    function closeWelc() {
      welc.classList.remove('in');
      setTimeout(function () { welc.classList.remove('open'); }, 450);
    }
    if (!welcSeen()) {
      var welcTimer = setTimeout(openWelc, delay * 1000);
      var onWelcScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        if (h > 0 && window.scrollY / h > 0.3) {
          clearTimeout(welcTimer); openWelc();
          window.removeEventListener('scroll', onWelcScroll);
        }
      };
      window.addEventListener('scroll', onWelcScroll, { passive: true });
    }
    welc.addEventListener('click', function (e) { if (e.target.closest('[data-welc-close]')) closeWelc(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && welc.classList.contains('open')) closeWelc();
    });
    var wForm = welc.querySelector('form');
    if (wForm && wForm.getAttribute('data-local') === 'true') {
      wForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var mail = wForm.querySelector('input[type="email"]');
        if (!mail || !mail.value || mail.value.indexOf('@') < 1) { if (mail) mail.focus(); return; }
        welc.classList.add('done');
      });
    } else if (welc.querySelector('.welc-form')) {
      /* formulaire client Shopify : on montre le code au retour d'inscription */
      if (/customer_posted=true/.test(location.search)) welc.classList.add('done');
    }
    var wCopy = welc.querySelector('[data-copy]');
    if (wCopy) {
      wCopy.addEventListener('click', function () {
        var code = (welc.querySelector('[data-code]') || {}).textContent || '';
        code = code.trim();
        var label = wCopy.getAttribute('data-label') || 'Copier';
        var done = function () {
          wCopy.textContent = wCopy.getAttribute('data-done') || 'Copié';
          setTimeout(function () { wCopy.textContent = label; }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (err) { }
          document.body.removeChild(ta); done();
        }
      });
    }
  }

  /* ================================================================
     HERO
     ================================================================ */
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  if (slides.length > 1) {
    var idx = 0, timer = null;
    var reduceHero = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var every = parseInt((document.querySelector('.hero') || {}).dataset ? document.querySelector('.hero').dataset.every : '', 10) || 6;
    function show(i) {
      slides[idx].classList.remove('on'); if (dots[idx]) dots[idx].classList.remove('on');
      idx = i;
      slides[idx].classList.add('on'); if (dots[idx]) dots[idx].classList.add('on');
    }
    function next() { show((idx + 1) % slides.length); }
    function startHero() { if (!reduceHero) timer = setInterval(next, every * 1000); }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { clearInterval(timer); show(i); startHero(); });
    });
    startHero();
  }

  /* ================================================================
     PARALLAXE — coupée sur écran tactile
     ================================================================ */
  var pars = [].slice.call(document.querySelectorAll('[data-par]'));
  var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  var reduceMotion = coarsePointer ||
    (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (coarsePointer) pars.forEach(function (el) { el.style.willChange = 'auto'; });
  var pTick = false;
  function parallax() {
    pTick = false;
    if (reduceMotion) return;
    var vh = window.innerHeight;
    for (var i = 0; i < pars.length; i++) {
      var el = pars[i], r = el.getBoundingClientRect();
      if (r.bottom < -150 || r.top > vh + 150) continue;
      var d = ((r.top + r.height / 2) - vh / 2) / vh;
      var f = parseFloat(el.getAttribute('data-par')) || 0;
      el.style.transform = 'translate3d(0,' + (-d * f).toFixed(1) + 'px,0) scale(1.14)';
    }
  }
  function pRaf() { if (!pTick) { pTick = true; requestAnimationFrame(parallax); } }
  window.addEventListener('scroll', pRaf, { passive: true });
  window.addEventListener('resize', pRaf, { passive: true });
  parallax();

  /* ================================================================
     MENU MOBILE
     ================================================================ */
  var burger = document.getElementById('burger'), mm2 = document.getElementById('mobileMenu');
  if (burger && mm2) {
    var setMenu = function (open) {
      mm2.classList.toggle('open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? t('menu_close', 'Fermer le menu') : t('menu_open', 'Ouvrir le menu'));
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { var f = mm2.querySelector('.mm-close'); if (f) f.focus(); }
      else burger.focus();
    };
    burger.addEventListener('click', function () { setMenu(!mm2.classList.contains('open')); });
    var mmClose = document.getElementById('mmClose');
    if (mmClose) mmClose.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mm2.classList.contains('open')) setMenu(false);
    });
    mm2.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setMenu(false); });
    });
  }

  /* ================================================================
     NAV, BARRE D'ACHAT, APPARITIONS
     ================================================================ */
  var nav = document.getElementById('nav');
  var sticky = document.getElementById('stickyBuy');

  function onScroll() {
    if (nav) nav.classList.add('solid');
    if (sticky) {
      var buy = document.querySelector('.buy');
      var past = buy && buy.getBoundingClientRect().bottom < 40;
      var foot = document.querySelector('.site-footer');
      if (past && foot && foot.getBoundingClientRect().top < window.innerHeight - 60) past = false;
      sticky.classList.toggle('show', !!past);
    }
  }

  var ticking = false;
  function sweep() {
    ticking = false;
    document.querySelectorAll('.rv').forEach(function (el) {
      if (el.classList.contains('in')) return;
      if (el.offsetParent === null) return;
      if (el.getBoundingClientRect().top < window.innerHeight * 0.95) el.classList.add('in');
    });
  }
  function rafSweep() { if (!ticking) { ticking = true; requestAnimationFrame(sweep); } }

  window.addEventListener('scroll', function () { onScroll(); rafSweep(); }, { passive: true });
  window.addEventListener('resize', sweep, { passive: true });
  window.addEventListener('load', sweep);

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  }

  onScroll(); sweep();

  /* Éditeur de thème : une section re-rendue n'a plus ses écouteurs.
     On recharge la page une seule fois, et uniquement dans l'éditeur,
     pour ne pas risquer une boucle de rechargements. */
  if (window.Shopify && window.Shopify.designMode) {
    var reloadedOnce = false;
    document.addEventListener('shopify:section:load', function () {
      if (reloadedOnce) return;
      reloadedOnce = true;
      location.reload();
    });
  }
})();
